export enum AnalyticEvents {
    PROFILE_POPOVER_OPENED = 'profile_popover_opened',
    CHANNEL_MEMBER_REMOVED = 'channel_member_removed',
}
